import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=1fd8ce86&scoped=true&"
import script from "./Contribution.vue?vue&type=script&lang=js&"
export * from "./Contribution.vue?vue&type=script&lang=js&"
import style0 from "./Contribution.vue?vue&type=style&index=0&id=1fd8ce86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8ce86",
  null
  
)

export default component.exports